// import { getUrlBoolean } from '@/helpers/UrlParam';
import { createRoot } from 'react-dom/client';
// import VConsole from 'vconsole';
import { App } from './App.jsx';
import '@/services/ResizeService';
import '@/services/AudioServiceHowler';
// import '@/services/ContextMenuService';
// import '@/libs/gsap';

import '@/styles/core.scss';
import '@/styles/shared.scss';
import '@/styles/app/index.scss';

// if (getUrlBoolean('console', false)) {
//   const vConsole = new VConsole();
// }

const rootContainer = document.getElementById('root');
const root = createRoot(rootContainer);

root.render(<App />);
